import React from "react";
import { Box } from "@chakra-ui/react";
import "./AnalogClock.css";
const weekDays = [
    "Dimanche",
    "Lundi",
    "Mardi",
    "Mercredi",
    "Jeudi",
    "Vendredi",
    "Samedi",
];
export const AnalogClock = ({ backgroundColor = "#FFFFFF", color = "#333333", dayBackgroundColor = "#CCCCCC", dayColor = "#000000", hoursNeedleColor = "#333333", minutesNeedleColor = "#666666", secondsNeedleColor = "#FFD700", widgetWidth, date, }) => {
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();
    const hoursDeg = hours * 30 + minutes * (360 / 720);
    const minutesDeg = minutes * 6 + seconds * (360 / 3600);
    const secondsDeg = seconds * 6;
    return (React.createElement(Box, { className: "clock", backgroundColor: backgroundColor, width: `${widgetWidth}px`, borderRadius: "50%", border: `${(14 / 300) * widgetWidth}px solid ${color}`, position: "relative", sx: { aspectRatio: "1/1" } },
        React.createElement(ClockNoRerender, { date: date, widgetWidth: widgetWidth, color: color, dayBackgroundColor: dayBackgroundColor, dayColor: dayColor }),
        React.createElement(Box, null,
            React.createElement(Box, { className: "hour-hand", position: "absolute", zIndex: "5", width: `${(4 / 300) * widgetWidth}px`, height: `${(65 / 300) * widgetWidth}px`, bgColor: hoursNeedleColor, left: "50%", marginLeft: `-${4 / 2}px`, top: `${(70 / 300) * widgetWidth}px`, transformOrigin: `50% ${(63 / 300) * widgetWidth}px`, borderTopLeftRadius: "50%", borderTopRightRadius: "50%", transform: `rotate(${hoursDeg}deg)` }),
            React.createElement(Box, { className: "minute-hand", position: "absolute", zIndex: "6", width: `${(4 / 300) * widgetWidth}px`, height: `${(100 / 300) * widgetWidth}px`, backgroundColor: minutesNeedleColor, left: "50%", marginLeft: `-${4 / 2}px`, top: `${(35 / 300) * widgetWidth}px`, transformOrigin: `50% ${(100 / 300) * widgetWidth}px`, borderTopLeftRadius: "50%", borderTopRightRadius: "50%", transform: `rotate(${minutesDeg}deg)` }),
            React.createElement(Box, { className: "second-hand", position: "absolute", zIndex: "7", width: `${(2 / 300) * widgetWidth}px`, height: `${(110 / 300) * widgetWidth}px`, backgroundColor: secondsNeedleColor, left: "50%", marginLeft: `-${2 / 2}px`, top: `${(25 / 300) * widgetWidth}px`, transformOrigin: `50% ${(110 / 300) * widgetWidth}px`, borderTopLeftRadius: "50%", borderTopRightRadius: "50%", transform: `rotate(${secondsDeg}deg)` }))));
};
const ClockNoRerender = React.memo(({ date, widgetWidth, color, dayBackgroundColor, dayColor, }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { sx: {
                ".info": {
                    position: "absolute",
                    width: `${(120 / 300) * widgetWidth}px`,
                    height: `${(20 / 300) * widgetWidth}px`,
                    borderRadius: `${(7 / 300) * widgetWidth}px`,
                    background: dayBackgroundColor,
                    textAlign: "center",
                    lineHeight: `${(20 / 300) * widgetWidth}px`,
                    color: dayColor,
                    fontSize: `${(11 / 300) * widgetWidth}px`,
                    left: "50%",
                    transform: "translateX(-50%)",
                    fontWeight: 700,
                    zIndex: 3,
                    letterSpacing: `${(3 / 300) * widgetWidth}px`,
                    fontFamily: "Poiret One",
                },
            } },
            React.createElement(Box, { className: "info date", top: `${(75 / 300) * widgetWidth}px` }, `${date.getDate()}/${(date.getMonth() + 1)
                .toString()
                .padStart(2, "0")}/${date.getFullYear()}`),
            React.createElement(Box, { className: "info day", top: `${(170 / 300) * widgetWidth}px` }, weekDays[date.getDay()])),
        React.createElement(Box, { sx: {
                span: {
                    display: "inline-block",
                    position: "absolute",
                    color,
                    fontSize: `${(22 / 300) * widgetWidth}px`,
                    fontWeight: 700,
                    zIndex: 4,
                    fontFamily: "Poiret One",
                },
            } },
            React.createElement(Box, { as: "span", top: `${(120 / 300) * widgetWidth}px`, right: `${(30 / 300) * widgetWidth}px` }, "3"),
            React.createElement(Box, { as: "span", bottom: `${(30 / 300) * widgetWidth}px`, left: "50%", marginLeft: `-${(5 / 300) * widgetWidth}px` }, "6"),
            React.createElement(Box, { as: "span", top: `${(120 / 300) * widgetWidth}px`, left: `${(32 / 300) * widgetWidth}px` }, "9"),
            React.createElement(Box, { as: "span", top: `${(30 / 300) * widgetWidth}px`, left: "50%", marginLeft: `-${(8 / 300) * widgetWidth}px` }, "12")),
        Array.from({ length: 60 }, (item, index) => index).map((number, index) => {
            return (React.createElement(Box, { className: "diallines", transform: `rotate(${6 * number}deg)`, transformOrigin: `50% ${widgetWidth / 2 - (14 / 300) * widgetWidth}px`, position: "absolute", zIndex: "2", left: "50%", marginLeft: `-${(1 / 300) * widgetWidth}px`, bgColor: color, key: `analog-clock-dialline-${index}`, width: number % 5 === 0
                    ? `${(4 / 300) * widgetWidth}px`
                    : `${(2 / 300) * widgetWidth}px`, height: number % 5 === 0
                    ? `${(25 / 300) * widgetWidth}px`
                    : `${(15 / 300) * widgetWidth}px` }));
        }),
        React.createElement(Box, { className: "dot", width: "5%", height: "5%", borderRadius: "50%", position: "absolute", zIndex: "10", inset: "0", bgColor: color, margin: "auto" })));
}, (prevProps, nextProps) => {
    if (prevProps.color !== nextProps.color)
        return false;
    if (prevProps.dayBackgroundColor !== nextProps.dayBackgroundColor)
        return false;
    if (prevProps.dayColor !== nextProps.dayColor)
        return false;
    if (prevProps.widgetWidth !== nextProps.widgetWidth)
        return false;
    return true;
});
